module.exports = __webpack_public_path__ + "media/images/b2b_admin/reports_shortcut_icon-b0989993cef827b54ef0dd7a7f19481a.svg";